"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * The convention we are following for keys here is -
 *
 * <AreaOfTheApplication>_<Section>_<TypeOfElementThisWillBeUsedIn>
 *
 * Use the Universal prefix for anything that will be used generally such as confirmation dialogs.
 * eg:
 *
 * Universal_ConfirmationDialog_ApplyButton: 'Apply',
 */
var _default = exports["default"] = {
  Notification_ReturnFromInactivity_Title: 'Please keep this browser tab in focus to avoid connectivity issues.',
  ControlPanel_Unmute_Title: 'Unmute?',
  ControlPanel_Unmute_Body: "Everyone will hear you, but you'll stay off-camera.",
  ControlPanel_CancelUnmuteButton: 'Stay muted',
  FeaturedScreen_Popover: 'Both a screen share source and a camera source must be enabled first',
  FeaturedMedia_Popover: 'Both a media source and a camera source must be enabled first',
  FeaturedContent_Popover: 'Both a content source and a camera source must be enabled first',
  FeaturedPresenter_Popover: 'One or more camera sources must be selected',
  SideBySide_Popover: 'One or more camera sources must be selected',
  Grid_Popover: 'One or more camera sources must be selected',
  Source_Spotlight_Popover: 'Spotlight on stage',
  Source_Pinned_Popover: 'Feature on stage',
  Mic_On_Popover: 'microphone is On. Click to turn their microphone Off.',
  Mic_Off_Popover: 'microphone is Off. Click to turn their microphone On.',
  Camera_On_Popover: 'camera is On. Click to turn their camera Off.',
  Camera_Off_Popover: 'camera is Off. Click to turn their camera On',
  Camera_Unavailable_Popover: 'No camera available',
  Camera_Permission_Popover: 'Open your browser settings and allow access to camera',
  Volume_Off_Popover: 'Turn the audio off. The slider changes the volume level.',
  Volume_On_Popover: 'Turn the audio on. The slider changes the volume level.',
  Loop_Button_Popover: 'Loop',
  Select_Source_Popover: 'Select',
  Deselect_Source_Popover: 'Deselect',
  Speaker_Selected_Popover: 'speaker',
  Source_Selected_Popover: 'source',
  PresenterTitle_Mic_Popover: "Speaker's",
  CameraCount_Popover: 'A max of ten cameras can be active at a time',
  ScreenShareCount_Popover: 'A max of two screen shares can be active at one time',
  ChatButton_Popover: 'Private chat with the hosts and speakers',
  KnockNotificationButton_Popover: 'Requests from speakers',
  StreamButton_NoDestination_Popover: 'There is still no stream destination set. Streaming cannot begin.',
  StreamButton_Time_Popover: 'Live streaming will be available 90 minutes before the scheduled presentation.',
  StreamButton_NotAvailable_Popover: 'Live streaming is no longer available because the presentation ended',
  KnockApproveButton_Popover: 'Approve request',
  KnockDenyButton_Popover: 'Deny request',
  PoorNetwork_Popover: 'Poor connection',
  GoodNetwork_Popover: 'Good connection',
  ExcellentNetwork_Popover: 'Excellent connection',
  NoNetworkData_Popover: 'No network data',
  MeetingEnded_AudioJoinedFromAnotherDevice_Title: 'Session Already Open',
  MeetingEnded_AudioJoinedFromAnotherDevice_Message: 'You have another session open in a different browser. To continue here, close the other browser and refresh this page.',
  MeetingEnded_TaskFailed_Title: 'Lost connection to meeting',
  MeetingEnded_TaskFailed_Message: 'Check your internet connection and refresh the page if the connection is not restored.',
  MeetingEnded_TaskFailed_MessageSuffix: 'Refresh will not disrupt stream / records',
  MeetingEnded_Default_Title: 'This Studio session has ended'
};